//@ts-check

// External
import React, { useEffect } from "react"

// Internal
import useStyles from "./enter-eth-address.styles"
import { requestJSON } from "../../utils/request-module"
const { REQUEST_STATES } = require("shared/consts")
import ChooseToken from "./choose-token"
import EnterMainnetAddress from "./enter-mainnet-address"
import { extractSolidityCompilerVersion } from "../../utils/extractSolidityCompilerVersion"
import CONSTS from "../../../../shared/consts"
import { track } from "../../utils/tracking"
import web3 from "web3"
import { isValidAddress } from "src/utils/is-valid-address"
var EnterETHAddress = function ({
  onChange,
  inputMethod,
  mainnetRequestState,
  setCode,
  setMainnetRequestState,
  inputAddress,
  setInputAddress,
  chosenToken,
  setChosenToken,
  setLoadingSolidityState,
  loading_solidity_state,
  setCompilerVersion,
  closePopover = () => {},
  isAutoSubmit = false,
  isInPopover = false,
  setFiles,
  setFilesFromMainnet = undefined,
}) {
  // States

  // Effects:

  // Variables:
  const classes = useStyles({})
  // Functions

  useEffect(() =>{
    setMainnetRequestState(REQUEST_STATES.READY)
  },[])

  const mainnetAddressChangeHandler = (e) => {
    setMainnetRequestState(REQUEST_STATES.READY)
    setInputAddress(e.target.value)
    setChosenToken("")
  }

  const onChangeToken = ({ target }) => {
    setChosenToken(target.value)
    if (!target.value) {
      setInputAddress("")
      setMainnetRequestState(REQUEST_STATES.READY)
      return
    }
    const selectedToken = (target.value && JSON.parse(target.value)) || {}
    // setSelectValue(selectedToken)
    setInputAddress(selectedToken.token)
    if (isAutoSubmit) {
      submitInputAddress(selectedToken.token)
      onChange()
    } else {
      setMainnetRequestState(REQUEST_STATES.READY)
    }
  }

  const submitInputAddress = async (token) => {
    if (!isValidAddress(inputAddress)) {
      console.log("invalid address")
    } else {
      const currentSelectedToken = chosenToken && JSON.parse(chosenToken).name
      track(CONSTS.MIXPANEL_EVENTS.EXTRACT_MAINNET_ADDRESS, {
        mainnetAddress: inputAddress,
        selectedToken: currentSelectedToken,
      })

      setLoadingSolidityState(true)
      var res = await requestJSON("POST", "/get_solidity_by_address", {
        ethAddress: token || inputAddress,
      })
      setLoadingSolidityState(false)
      if (!res) return
      if (res.error) {
        setMainnetRequestState(REQUEST_STATES.FAILURE)
        return
      }
      setMainnetRequestState(REQUEST_STATES.SUCCESS)
      let filename = inputAddress
      if (currentSelectedToken) {
        const indexOfOpeningPathenthese = currentSelectedToken.indexOf("(")
        const indexOfClosingPathenthese = currentSelectedToken.indexOf(")")
        filename = currentSelectedToken.slice(
          indexOfOpeningPathenthese + 1,
          indexOfClosingPathenthese,
        )
      }

      let parsedSolidity = parseSolidityCode(res.solidity)

      setFilesFromMainnet(parsedSolidity)

      const isValidCompiler = /^v\d+\.\d+\.\d+(\+commit\.[0-9a-zA-Z]+)?$/m.test(
        res.compilerVersion,
      )
      const newCompilerVersion = isValidCompiler
        ? res.compilerVersion
        : extractSolidityCompilerVersion(res.solidity)
      setCompilerVersion(newCompilerVersion)
      setTimeout(() => {
        closePopover()
      }, 2000);

    }
  }

  function parseSolidityCode(solidity) {
    let files = []

    // Check if the input is likely to be a JSON object for multiple files
    if (solidity.trim().startsWith("{")) {
      // Clean up the input to make it valid JSON
      const cleanedSolidity = solidity.replace(/{{/g, "{").replace(/}}/g, "}")

      try {
        const parsed = JSON.parse(cleanedSolidity)

        if (parsed.language === "Solidity" && parsed.sources) {
          // Handle multiple file case
          for (const [path, { content }] of Object.entries(parsed.sources)) {
            files.push({ path, content })
          }

          // Remove common prefix from file paths
          const paths = files.map((file) => file.path)
          const updatedPaths = removeCommonPrefix(paths)

          // Update file paths in the result
          files = files.map((file, index) => ({
            path: updatedPaths[index],
            content: file.content,
          }))
        }
      } catch (e) {
        console.error("Failed to parse JSON:", e)
      }
    } else {
      // Handle single file case
      files.push({ path: "main.sol", content: solidity })
    }

    return files
  }

  function removeCommonPrefix(uris) {
    if (uris.length === 0) return uris

    // Remove leading '/' from each URI if it exists
    uris = uris.map((uri) => (uri.startsWith("/") ? uri.slice(1) : uri))

    // Split all URIs into parts
    let splitUris = uris.map((uri) => uri.split("/"))

    // Find the common prefix length
    let commonPrefixLength = splitUris[0].length
    for (let i = 1; i < splitUris.length; i++) {
      for (let j = 0; j < commonPrefixLength; j++) {
        if (splitUris[i][j] !== splitUris[0][j]) {
          commonPrefixLength = j
          break
        }
      }
    }

    // Remove the common prefix from all URIs
    let result = splitUris.map((parts) =>
      parts.slice(commonPrefixLength).join("/"),
    )

    return result
  }

  const onExtractFromMainnet = () => {
    submitInputAddress();
    onChange();
  }

  return (
    <div>
      {inputMethod === "token" && (
        <ChooseToken
          onChangeToken={onChangeToken}
          chosenToken={chosenToken}
          inputAddress={inputAddress}
          loadingSolidityState={loading_solidity_state}
          onExtractFromMainnet={onExtractFromMainnet}
          mainnetRequestState={mainnetRequestState}
          isAutoSubmit={isAutoSubmit}
          isInPopover={isInPopover}
        />
      )}
      {inputMethod === "mainnet" && (
        <EnterMainnetAddress
          inputAddress={inputAddress}
          mainnetAddressChangeHandler={mainnetAddressChangeHandler}
          loadingSolidityState={loading_solidity_state}
          onExtractFromMainnet={onExtractFromMainnet}
          mainnetRequestState={mainnetRequestState}
          isAutoSubmit={isAutoSubmit}
          isInPopover={isInPopover}
        />
      )}
    </div>
  )
}

export default EnterETHAddress
